export default "__VITE_ASSET__DFpXlMRS__"